import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'

export const StickerMenuTextPanel = observer((): JSX.Element => {
  const [, store] = useStickerStore()

  return (
    <div className="max-w-[250px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={store.sticker.title}
          onClickOnSettingHandler={store.closeStickerMenu}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className="text-14 mt-8 mb-16 mx-8">
          <p>{Lang.msg.dragStickerToTask}</p>
          <p className="mt-16">{Lang.msg.myStickers.textStickerStates}</p>
        </div>
      </div>
    </div>
  )
})
